/**
 * Return the timezone of the user's browser.
 */
export const getTimezone = () => {
	try {
		return Intl.DateTimeFormat().resolvedOptions().timeZone;
	}
	catch {
		return null;
	}
};